import { faPlus, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { TFunction } from 'i18next'
import React, { useContext, useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Authorization from '../../../Authentication/Authorization'
import DialogContext from '../../../Authentication/DialogContext'
import { ConfirmDialogProps } from '../../../components/ConfirmDialog'
import DataTable from '../../../components/DataTable'
import { EditDialogProps } from '../../../components/EditDialog'
import ProtectedButton from '../../../components/ProtectedButton'
import Loading from '../../../layout/Loading'
import SsoProxyService from '../../../service/SsoProxyService'

const RewritingRules = () => {
  const { t } = useTranslation()
  const [rewritingRules, setRewritingRules] = useState({} as any)
  const [loading, setLoading] = useState(true)
  const { confirmDialogPropsSetter, editDialogPropsSetter } = useContext(DialogContext)

  useEffect(() => {
    async function loadData() {
      const rewritingRules = await SsoProxyService.getRewritingRules()
      setRewritingRules(rewritingRules)
    }
    loadData().finally(() => setLoading(false))
  }, [])

  const columns = useMemo(() => {
    return [
      {
        text: t('ssoProxy.regEx'),
        dataField: 'regEx',
        sort: true,
      },
      {
        text: t('ssoProxy.replacementValue'),
        dataField: 'replacementValue',
        sort: true,
      },
      {
        dataField: 'df1',
        isDummyField: true,
        text: t('action'),
        headerAlign: 'center',
        formatter: (_cellData: any, row: any) => (
          <ProtectedButton
            permissions={Authorization.settings.ssoProxy.edit}
            variant='link'
            tooltip={t('delete')}
            className='text-danger text-link text-decoration-none text-right'
            onClick={() => deleteRewritingRulesDialog(row, t, setRewritingRules, confirmDialogPropsSetter)}>
            <FontAwesomeIcon icon={faTrashAlt} />
          </ProtectedButton>
        ),
      },
    ]
  }, [t, confirmDialogPropsSetter])

  return (
    <Loading isLoading={loading}>
      <DataTable data={rewritingRules} columns={columns} searchable={false} />
      <div className='text-right pr-1 ml-nfc-1'>
        <ProtectedButton variant='primary' className='ml-auto my-auto' onClick={newRewritingRule} permissions={Authorization.settings.ssoProxy.edit}>
          <FontAwesomeIcon icon={faPlus} />
          <span className='ml-1 my-auto'>New Rewriting Rule</span>
        </ProtectedButton>
      </div>
    </Loading>
  )

  function newRewritingRule() {
    const editDialogProps: EditDialogProps = {
      show: true,
      header: t('ssoProxy.rewritingRulesCreateHeader'),
      onSubmit: SsoProxyService.createRewritingRules,
      onSubmitExtraArgs: [t, setRewritingRules],
      data: [
        {
          id: 'regEx',
          type: 'text',
          label: t('ssoProxy.regEx'),
          placeholder: t('ssoProxy.regEx'),
          requiredMessage: t('inValidMessage', { label: 'RegEx value' }),
          required: true,
        },
        {
          id: 'replacementValue',
          type: 'text',
          label: t('ssoProxy.replacementValue'),
          placeholder: t('ssoProxy.replacementValue'),
          requiredMessage: t('inValidMessage', { label: 'replacement value' }),
          required: true,
        },
      ],
      labelGridSize: 3,
    }

    editDialogPropsSetter(editDialogProps)
  }
}

function deleteRewritingRulesDialog(row: any, t: TFunction, setRewritingRules: React.Dispatch<any>, confirmDialogPropsSetter: any) {
  const props: ConfirmDialogProps = {
    show: true,
    header: t('ssoProxy.rewritingRulesDeleteHeader'),
    onSubmit: SsoProxyService.deleteRewritingRules,
    onSubmitExtraArgs: [row.id, t, setRewritingRules],
    body: t('ssoProxy.rewritingRulesDeleteBody', { regEx: row.regEx }),
  }

  confirmDialogPropsSetter(props)
}

export default RewritingRules
